// extracted by mini-css-extract-plugin
module.exports = {"banner":"az_zkb","overrideMainBody":"az_Akb","defaultBodyText":"az_Bkb"};